import React from 'react';
import {
    BodyLargeRegular,
    BodyMediumRegular,
    Button,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

const RuleEditorDeleteSheet = ({
    isOpen,
    onClose,
    onDelete,
}: {
    isOpen: boolean;
    onClose: () => void;
    onDelete: () => void;
}) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={false}
            isInsideModal
        >
            <YStack gap={24}>
                <YStack gap={4}>
                    <BodyLargeRegular>
                        Are you sure you want to delete this rule?
                    </BodyLargeRegular>
                    <BodyMediumRegular color="$gray1000">
                        Deleting this rule will also reset the calculation for
                        your monthly and annual contribution limits.
                    </BodyMediumRegular>
                </YStack>
                <YStack gap={8}>
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        tone="danger"
                        text="Yes, delete this rule"
                        onPress={onDelete}
                    />
                    <Button
                        variant={ButtonVariant.TERTIARY}
                        text="Cancel"
                        onPress={onClose}
                    />
                </YStack>
            </YStack>
        </Sheet>
    );
};

export default RuleEditorDeleteSheet;
